export const experiencesDE = [
  {
    title: "FullStack Entwickler",
    company: "TrustYou",
    startDate: "Apr 2022",
    endDate: "May 2026",
    type: "Vollzeit",
    location: "München, Bayern, Deutschland",
    about: [
      "TrustYou ist eine AI-first, globale Hospitality-Plattform, die Hospitality-Marken dabei unterstützt, Customer Excellence zu verbessern, Direktbuchungen zu steigern, operative Kosten zu senken und Gästedaten in umsatzgenerierende Chancen zu verwandeln. Seit 2008 ermöglicht TrustYou Hotels, Destinationen und Reisemarken weltweit, Gästefeedback, Kundendaten und automatisierte Interaktionen in umsetzbare Erkenntnisse und personalisierte Gästeerlebnisse zu transformieren.",
      "Die Plattform kombiniert eine Customer Experience Platform (CXP), eine Customer Data Platform (CDP) und AI Agents, um Unternehmen dabei zu helfen, die Servicequalität zu verbessern, Kundendaten DSGVO-konform zu verwalten, mit KI auf Feedback zu reagieren, repetitive Aufgaben zu automatisieren und die Gästekommunikation entlang der gesamten Customer Journey zu optimieren.",
    ],
    responsible: "Zuständigkeiten:",
    responsibilities: [
      "Entwicklung von Full-Stack-Systemen mit Python, Django, FastAPI, React und Next.js",
      "Entwicklung von CXP-, CDP-, KI-gestützten Features und Integrationen mit Reiseplattformen",
      "Leitung der Feature-Umsetzung von der Planung bis zum Produktions-Release",
      "Bearbeitung von Incidents, Root-Cause-Analysen und operativen Verbesserungen",
      "Mentoring von Engineers durch Reviews, Testing und technische Anleitung",
    ],

    contribution: "Beiträge:",
    contributions: [
      "Migration wichtiger Datenflüsse, Produktfeatures und Integrationen von Classic zu CXP mit minimaler Geschäftsunterbrechung",
      "Reduzierung wiederkehrender Datensynchronisationsfehler um 35 % durch verbesserte Pipeline-Zuverlässigkeit und Observability",
      "Umsetzung von Direct-Response-Features für Google- und Booking.com-Integrationen zur Unterstützung von Feedback-Workflows über 2 große Reiseplattformen",
      "Reduzierung des Wartungsaufwands in Legacy-Alerting- und Operations-Systemen um 30 % durch Refactoring und Modernisierung",
      "Entwicklung gemeinsamer Services und wiederverwendbarer Komponenten, die von Engineering-Teams übernommen wurden",
      "Reduzierung manueller Aufwände in ausgewählten Feedback-Workflows um 25 % durch KI-gestützte kundenorientierte Features",
      "Technische Kommunikation mit Stakeholdern, einschließlich Accor und Louvre Hotels, über Product, Engineering und Operations hinweg",
      "Reduzierung wiederkehrender Incidents um 20 % durch strukturierte Triage, Root-Cause-Analysen und Follow-up-Maßnahmen",
    ],

    achievement: "Errungenschaften:",
    achievements: [
      "Verbesserung der Zuverlässigkeit und Wartbarkeit von kundenorientierten und internen Systemen",
      "Reduzierung integrationsbezogener Incidents in CXP-Datenpipelines",
      "Verbesserung der Engineering-Produktivität durch gemeinsame Services und wiederverwendbare Komponenten",
      "Unterstützung der Modernisierung zentraler Plattformbereiche von Classic zu CXP",
    ],
    stack: [
      "Python",
      "FastAPI",
      "Django",
      "Flask",
      "React",
      "Docker",
      "Kubernetes",
    ],
    links: [
      {
        title: "trustyou.com",
        href: "https://www.trustyou.com",
      },
    ],
    showExperiences: true,
    showExperiencesPrint: true,
  },
  {
    title: "CTO - Web Entwickler",
    company: "SnappCarFix / CarFillo",
    startDate: "Sep 2019",
    endDate: "Apr 2022",
    type: "Vollzeit",
    location: "Isfahan, Iran",
    about: [
      "SnappCarFix ist eine Online-Plattform für Autoteile und Dienstleistungen, die von Snapp (Uber-Klon) bereitgestellt wird.",
      "Die Plattform umfasst Web-Apps für Geschäfte, Servicecenter, Agenten und Verkäufer, um Produkte/Dienstleistungen wie zum Beispiel Öl, Akku, Motorteile, Autowaschanlagen usw. anzubieten, mit 7 Liefer-/Servicelösungen pro Produkt.",
      "CarFillo vertreibt Produkte an Servicecenter, Es ist ein Online Shop, die Servicecenter erhalten Gutschriften auf der Grundlage ihrer Dienstleistungen auf SnappCarFix.",
    ],
    responsible: "Zuständigkeiten:",
    responsibilities: [
      "Führung eines Entwicklerteams (10-15 Entwickler)",
      "Entwicklung und Implementierung der Plattform",
      "Spezifizierung der technischen Struktur und der Tools der Plattform",
      "Steuerung und Ausrichtung der technischen Teile von Verträgen",
    ],
    contribution: "Beiträge:",
    contributions: [
      "Umstrukturierung der Plattform von WordPress und .net zu Python/Django/React, Bearbeitung von mehr Anfragen, mit besserer UI/UX und weniger Entwicklungsaufwand",
      "Umstellung des Entwicklungsprozesses auf eine TDD-Version, verwaltet mit agilen Methoden",
      "Einführung eines Vorstellungsgesprächs in den Onboarding-Prozess, über 50 Vorstellungsgespräche und Einstellung von 20 Mitarbeitern",
      "Ersetzung der ServiceCenters-App durch PWA, Aktualisierungen in Echtzeit, 60% schnellere Übermittlung von Dienstleistungen",
      "Entwicklung einer Agenten-App, die die Datenerfassung um 80% beschleunigt und vollständig papierlos macht",
      "Entwicklung eines Kernmoduls zur Strukturierung von Django und React Projekten und Dienstprogrammen",
      "Umstrukturierung von DevOps-Lösungen, Hinzufügen von Cache Layers, Docker, GitLab CI/CD, Monitoring, Logging und Backup-Plänen, 10k RPS Handling und 50% schnellere Antwortzeiten",
      "Entwicklung von Buchhaltungs- und Logistikmodulen, Verringerung manueller Arbeit und menschlicher Fehler",
      "Entwicklung einer Verkäuferplattform zur schnelleren Aktualisierung von Lagerbeständen und Preisen",
      "Umschreibung des Panda-Projekts auf Matrix mit Django 3.2, Hinzufügen von Kubernetes und gesicherten Anmeldeinformationen",
      "Umschreiben des T2Bco-Projekts zu Radix, von .net zu Python/Django/React",
    ],
    achievement: "Errungenschaften:",
    achievements: [
      "Spitzenposition im Schnellservice-E-Commerce im Nahen Osten",
      "Aufzeichnung von über 1.5 Millionen Nutzern und deren Fahrzeugdaten",
      "Mehr als 16000 Servicestellen im ganzen Land",
      "Erfassung von über 15000 Online-Bestellungen und 2500 Dienstleistungen pro Tag",
      "Erhöhung des Anteils des elektronischen Handels am BIP um 1.5%, Senkung der Logistikkosten um 45%",
    ],
    stack: ["Python", "Django", "React", "Memcached", "Celery", "Docker"],
    links: [
      {
        title: "snappcarfix.com",
        href: "https://snappcarfix.com",
      },
      {
        title: "ag.snappcarfix.com",
        href: "https://ag.snappcarfix.com",
      },
      {
        title: "sc.snappcarfix.com",
        href: "https://sc.snappcarfix.com",
      },
      {
        title: "carfillo.com",
        href: "https://carfillo.com",
      },
    ],
    showExperiences: true,
    showExperiencesPrint: true,
  },
  {
    title: "Web Entwickler",
    company: "Press'nXPress",
    startDate: "Jun 2019",
    endDate: "Nov 2019",
    type: "Teilzeit (Remote)",
    location: "Ontario, Kanada",
    about: [
      "Press'nXPress kontrolliert und bewertet die Rückmeldungen in der Echtzeit-Plattform, die Daten aus verschiedenen Quellen sammelt, wie z.B. Terminals und Chips, die unser Unternehmen entwickelt hat, SMS, Sprache, etc.",
      "Die Daten werden gespeichert und in mehreren Diagrammen analysiert, so dass die Benutzer die erforderlichen Abfragen durchführen könnten. Wir hatten bereits Kunden wie Fluggesellschaften, Regierungen, Einkaufszentren und Fitnessstudios.",
    ],
    responsible: "Zuständigkeiten:",
    responsibilities: [],
    contribution: "Beiträge:",
    contributions: [
      "Entwicklung von Backend, Frontend und Adminpanels von scanortap mit NestJS und React",
      "Refaktorierung einiger Teile der Hauptplattform von SailJS zu NestJS und Angular zu React",
    ],
    achievement: "Errungenschaften:",
    achievements: [],
    stack: ["JS/TS", "NestJS", "React", "Angular", "MySQL"],
    links: [
      {
        title: "pressnxpress.com",
        href: "https://pressnxpress.com",
      },
      {
        title: "scanortap.com",
        href: "https://scanortap.com",
      },
    ],
    showExperiences: true,
    showExperiencesPrint: true,
  },
  {
    title: "Web Entwickler",
    company: "Motosel",
    startDate: "Sep 2018",
    endDate: "Sep 2019",
    type: "Teilzeit",
    location: "Isfahan, Iran",
    about: [
      "Plattform für Kfz-Verbrauchsmaterial, die mehrere Web-/Mobile-Apps für Servicecenter und Geschäfte beinhaltet.",
      "Das Ziel war es, Öl und verwandte Produkte mit tollen Sonderangeboten an Servicecenter zu vertreiben und ihre Kundenanzahl zu erhöhen.",
      "Das Unternehmen wurde später in zwei Unternehmen aufgespalten, CarFillo und SnappCarFix (unterstützt von Snapp, einem Uber-Klon im Iran), bei denen ich als CTO tätig bin.",
    ],
    responsible: "Zuständigkeiten:",
    responsibilities: [],
    contribution: "Beiträge:",
    contributions: [
      "Refaktorierung und Umstrukturierung des Kern-Backend-Projekts mit Python/Django",
      "Entwicklung eines Microservices zur Synchronisierung von Daten zwischen Stores und ServiceCentern",
      "Entwicklung eines Echtzeit-Nachrichtenmoduls für In-App-Chats",
    ],
    achievement: "Errungenschaften:",
    achievements: [],
    stack: ["Python", "Django", "JS/TS", "React", "ReactNative"],
    links: [],
    showExperiences: true,
    showExperiencesPrint: true,
  },
  {
    title: "Backend Entwickler",
    company: "Rahnema College",
    startDate: "Aug 2018",
    endDate: "Sep 2018",
    type: "Praktikum",
    location: "Teheran, Iran",
    about: [
      "Rahnama Hochschule ist eines der hochwertigsten Praktikumsprogramme im Iran, mit mehreren Fächern. Wie Entwicklung, Digitales Marketing und vieles mehr.",
      "Es werden 30 Praktikanten aus über 1000 Freiwilligen ausgewählt, nach einer Online-Prüfung und einem persönlichen Gespräch.",
      "Dieses Programm beinhaltet 2 Wochen Lernen technischen und sozialen Fähigkeiten (von DevOps bis Teamwork) und 8 Wochen Entwicklung.",
    ],
    responsible: "Zuständigkeiten:",
    responsibilities: [],
    contribution: "Beiträge:",
    contributions: [
      "Entwicklung und Verwaltung des Backend-Projekts (Kombination von Instagram- und Pinterest-Funktionen)",
      "Konfiguration und Implementierung des Projekts auf einem Linux-Server mit nginx und mysql",
    ],
    achievement: "Errungenschaften:",
    achievements: [],
    stack: ["Python", "Django", "JS/TS", "ReactNative", "MySQL", "Redis"],
    links: [
      {
        title: "github.com/Akaskhoone/",
        href: "https://github.com/Akaskhoone/",
      },
      {
        title: "rahnemacollege.com",
        href: "https://rahnemacollege.com",
      },
    ],
    showExperiences: true,
    showExperiencesPrint: true,
  },
  {
    title: "Web Entwickler",
    company: "Saj Tech",
    startDate: "Apr 2016",
    endDate: "May 2017",
    type: "Vollzeit",
    location: "Mashhad, Iran",
    about: [
      "Bei der Plattform handelte es sich um eine standortbasierte Liefer- und Verwaltungsanwendung für Geschäfte, mit Ideen der Lieferung mit Drohnen.",
      "Leider ging diese Firma nach zwei Jahren wegen fehlender Finanzierung nach zwei Jahren.",
    ],
    responsible: "Zuständigkeiten:",
    responsibilities: [],
    contribution: "Beiträge:",
    contributions: [
      "Entwicklung von Benutzer- und Lagermodulen mit Django",
      "Entwicklung von APIs für Administrationspanels und unsere Android-App",
      "Entwicklung von 3 Frontend-Projekten, darunter 2 Websites und ein Admin-Panel",
    ],
    achievement: "Errungenschaften:",
    achievements: [],
    stack: ["Python", "Django", "JS", "HTML", "CSS", "MySQL"],
    links: [],
    showExperiences: true,
    showExperiencesPrint: true,
  },
];
